import { environment } from "@environment/environment"

export const urlAuth = environment.apiService_Auth
export const urlErp = environment.apiService_Erp
export const urlReport = environment.apiService_Report
export const urlExport = environment.apiService_Export
export const urlProduccion = environment.apiService_Produccion
export const urlAdjuntos = environment.apiService_Adjuntos
export const urlFE = environment.apiService_FE
export const urlConfig = environment.apiService_Config
export const urlPlanilla = environment.apiService_Planilla
export const urlIA = environment.apiService_Ia